export const SetevayaData = [
    {
        title: "дом №2",
        year: '1969',
        floor: "5",
        apartment: "81",
        quantityLC: "82",
        livingArea: "3133,5",
        notLivinigArea: "нет",
        commonProperty: "256,9",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'setevaya/sofrino_setevaya_2_dogovor.pdf',
        protocolURL: 'protocol_1_2020-12-09.pdf',
    },

    {
        title: "дом №4",
        year: '1968',
        floor: "5",
        apartment: "76",
        quantityLC: "76",
        livingArea: "3081,9",
        notLivinigArea: "140,2",
        commonProperty: "243,5",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'setevaya/sofrino_setevaya_4_dogovor.pdf',
        protocolURL: 'protocol_1_2018-08-22.pdf',
    },

    {
        title: "дом №7",
        year: '1953',
        floor: "2",
        apartment: "8",
        quantityLC: "10",
        livingArea: "532,1",
        notLivinigArea: "нет",
        commonProperty: "47,5",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, канализация, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'setevaya/sofrino_setevaya_7_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №9",
        year: '1953',
        floor: "2",
        apartment: "8",
        quantityLC: "9",
        livingArea: "528,3",
        notLivinigArea: "нет",
        commonProperty: "47,4",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, канализация, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'setevaya/sofrino_setevaya_9_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №11",
        year: '1953',
        floor: "2",
        apartment: "8",
        quantityLC: "10",
        livingArea: "519,1",
        notLivinigArea: "нет",
        commonProperty: "46,4",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, канализация, электроснабжение",
        technicalSupport: "общедомовой прибор учета ХВС",
        contractURL: 'setevaya/sofrino_setevaya_11_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }

]